<template>
  <div>
    <el-form :model="query" ref="queryForm" :inline="true">
      <el-form-item label="订单状态：">
        <el-select v-model="query.state" placeholder="请选择" clearable size="small">
          <el-option label="待发货" :value="2"></el-option>
          <el-option label="待收货" :value="3"></el-option>
          <el-option label="已完成" :value="4"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="下单时间：">
        <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleDownload" size="mini">导出</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import goodsOrderApi from '@/api/order/goodsOrder'
export default {
  props: ['orderType'],
  data() {
    return {
      dateTime: [],
      list: [],
      total: 0,
      listLoading: true,
      query: {
        state: ''
      },
    }
  },
  created() {
  },
  methods: {
    handleDownload() {
      this.query.startTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[0] : undefined
      this.query.endTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[1] : undefined
      return this.$common.confirm('是否确认导出')
        .then(() => goodsOrderApi.exchangeOrderExport(this.query)).then((res) => {
          if (res.code === '0') {
            setTimeout(() => {
              this.$emit('created')
            }, 1000)

          }
        })
    },

  }

}
</script>

<style>
</style>